module.exports = __webpack_public_path__ + "img/191.06ef41dc.jpg";